<template>
  <div class="add-record-container">
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    
    <div class="main-content-wrapper">
      <el-row class="full-height">
        <el-col :span="4" class="sidebar-col">
          <MenuList></MenuList>
        </el-col>
        <el-col :span="20" class="content-col">
          <div class="page-header">
            <div class="page-title-section">
              <h1 class="page-title">添加数据</h1>
              <p class="page-subtitle">为表单 <strong>{{form_name}}</strong> 添加新的数据记录</p>
            </div>
            <div class="action-section">
              <el-button class="back-btn" @click="back()">
                <i class="el-icon-arrow-left"></i> 返回列表
              </el-button>
            </div>
          </div>

          <div class="form-container-wrapper">
            <div class="form-container">
              

              <!-- 表单字段 -->
              <div class="form-fields-container">
                <div class="fields-list">
                  <div v-for="(field,index) in formFields" :key="field.id" class="field-item">
                    <div class="field-header">
                      <div class="field-title">
                        <span class="field-number">{{index+1}}</span>
                        <span class="field-name">{{field.field_name}}</span>
                        <span v-if="field.optional!==1" class="required-star">*</span>
                      </div>
                      <div class="field-actions" v-if="showComment(field.field_comment)">
                        <span class="field-help-link" @click="showFieldComment(field.field_name,index)">
                          <i class="el-icon-question"></i> 查看填写说明
                        </span>
                      </div>
                    </div>
                    
                    <div class="field-type-hint">
                      <span class="field-type-label">字段类型：{{field.field_type}}</span>
                      <span v-if="field.optional===1" class="optional-label">（选填）</span>
                      <span v-else class="required-label">（必填）</span>
                    </div>

                    <!-- 文本字段 -->
                    <div v-if="field.field_type==='文本'" class="field-input-wrapper">
                      <el-input 
                        type="textarea" 
                        :rows="3" 
                        v-model="fieldValues[index]" 
                        placeholder="请输入内容"
                        class="text-field-input"
                        resize="none">
                      </el-input>
                    </div>

                    <!-- 数字字段 -->
                    <div v-if="field.field_type==='数字'" class="field-input-wrapper">
                      <el-input 
                        v-model="fieldValues[index]" 
                        placeholder="请输入数字"
                        class="number-field-input"
                        type="number">
                      </el-input>
                    </div>

                    <!-- 日期字段 -->
                    <div v-if="field.field_type==='日期'" class="field-input-wrapper">
                      <el-date-picker 
                        v-model="fieldValues[index]" 
                        value-format="yyyy-MM-dd" 
                        type="date"
                        placeholder="选择日期"
                        class="date-picker"
                        :clearable="false">
                      </el-date-picker>
                    </div>

                    <!-- 日期时间字段 -->
                    <div v-if="field.field_type==='日期时间'" class="field-input-wrapper">
                      <el-date-picker 
                        v-model="fieldValues[index]" 
                        type="datetime" 
                        placeholder="选择日期时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        class="datetime-picker"
                        :clearable="false">
                      </el-date-picker>
                    </div>

                    <!-- 自动时间字段 -->
                    <div v-if="field.field_type==='自动时间'" class="field-input-wrapper">
                      <el-input 
                        v-model="fieldValues[index]" 
                        :disabled="true"
                        class="auto-time-input">
                        <template slot="prepend"><i class="el-icon-time"></i></template>
                      </el-input>
                    </div>

                    <!-- 图片/视频/签名字段 -->
                    <div v-if="field.field_type==='图片' || field.field_type==='视频' || field.field_type==='签名'" class="field-notice">
                      <div class="notice-card">
                        <div class="notice-icon">
                          <i class="el-icon-mobile-phone"></i>
                        </div>
                        <div class="notice-content">
                          <h4>电脑端暂不支持</h4>
                          <p>此字段需要在手机端的多人填表小程序中操作</p>
                        </div>
                      </div>
                    </div>

                    <!-- 单选框字段 -->
                    <div v-if="field.field_type==='单选'" class="field-input-wrapper">
                      <el-radio-group v-model="fieldValues[index]" class="radio-group">
                        <el-radio 
                          :label="option" 
                          v-for="(option,optionIndex) in loadSingleOptions(field.field_name)"
                          :key="optionIndex"
                          class="radio-item">
                          {{option}}
                        </el-radio>
                      </el-radio-group>
                    </div>

                    <!-- 多选框字段 -->
                    <div v-if="field.field_type==='多选'" class="field-input-wrapper">
                      <el-checkbox-group v-model="fieldValues[index]" class="checkbox-group">
                        <el-checkbox 
                          :label="option.label" 
                          v-for="(option) in loadMutiOptions(field.field_name)"
                          :key="option.label"
                          class="checkbox-item">
                          {{option.label}}
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>

                    <!-- 条形码/二维码字段 -->
                    <div v-if="field.field_type==='条形码' || field.field_type==='二维码'" class="field-notice">
                      <div class="notice-card">
                        <div class="notice-icon">
                          <i class="el-icon-camera"></i>
                        </div>
                        <div class="notice-content">
                          <h4>扫码功能</h4>
                          <p>此字段需要在手机端使用摄像头扫码</p>
                        </div>
                      </div>
                    </div>

                    <!-- 身份证号字段 -->
                    <div v-if="field.field_type==='身份证号'" class="field-input-wrapper">
                      <el-input 
                        v-model="fieldValues[index]" 
                        placeholder="请输入身份证号"
                        class="id-card-input"
                        maxlength="18">
                      </el-input>
                    </div>

                    <!-- 手机号字段 -->
                    <div v-if="field.field_type==='手机号'" class="field-input-wrapper">
                      <el-input 
                        v-model="fieldValues[index]" 
                        placeholder="请输入手机号"
                        class="phone-input"
                        maxlength="11">
                      </el-input>
                    </div>

                    <!-- 邮箱字段 -->
                    <div v-if="field.field_type==='Email邮箱'" class="field-input-wrapper">
                      <el-input 
                        v-model="fieldValues[index]" 
                        placeholder="请输入邮箱地址"
                        class="email-input"
                        type="email">
                      </el-input>
                    </div>

                    <!-- 车牌号字段 -->
                    <div v-if="field.field_type==='车牌号'" class="field-input-wrapper">
                      <el-input 
                        v-model="fieldValues[index]" 
                        placeholder="请输入车牌号"
                        class="license-plate-input">
                      </el-input>
                    </div>
                  </div>
                </div>

                <!-- 操作按钮 -->
                <div class="form-actions">
                  <el-button 
                    type="primary" 
                    class="save-btn"
                    @click="saveFormData"
                    :loading="saving">
                    <i class="el-icon-check"></i> 保存数据
                  </el-button>
                  <el-button 
                    class="reset-btn"
                    @click="clearAllData">
                    <i class="el-icon-refresh"></i> 清空表单
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        form_id: '',
        formFields: [],
        form_name: [],
        fieldValues: [],
        fieldComments: [],
        remaid_minute: '',
        field_optionals: '',
        mutiSelectShow: '',
        form_comment: '',
        field_samples: [],
        field_options: [],
        mutiSelect: [],
        saving: false
      }
    },
    computed: {
      requiredFieldsCount() {
        if (!this.formFields.length) return 0
        return this.formFields.filter(field => field.optional !== 1).length
      }
    },
    created() {
      this.form_id = this.$route.params.form_id

      // console.log('>>>>>>>>>>>>', this.form_id)

      this.form_name = this.$route.params.form_name
      // console.log(this.$route.params)
      // this.form_id = 20980
      this.loadForm()
    },
    methods: {
      back() {
        let that = this
        this.$router.push({
          name: 'browse_all_data',
          params: {
            form_id: that.form_id,
            form_name: that.form_name
          }
        })
      },
      loadForm() {
        let that = this
        var requestUrl = '/form/web/_load_add_record_form.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.form_id

            }
          }).then(function(response) {
            that.formFields = response.data.formFields
            that.form_name = response.data.formName

            if (that.user_action === 'add_record') {
              that.fieldValues = []
            } else {
              that.fieldValues = response.data.fieldValues
            }

            that.fieldComments = response.data.formComments

            // that.fieldValues = res.data.fieldValues
            that.remaid_minute = response.data.remaid_minute

            that.field_optionals = response.data.field_optionals
            // console.log('optionals', that.field_optionals)

            that.clearAllData()

            that.form_comment = response.data.comment
            if (typeof (that.form_comment) !== 'undefined' && that.form_comment.length > 0) {
              that.hiddenCommentTipDialog = false
            } else {
              that.hiddenCommentTipDialog = true
            }

            that.field_samples = response.data.field_samples

            that.field_options = response.data.field_options

            // that.form_id = res.data.form_id

            // that.initImageData()
            // that.initVideoData()
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      showFieldComment(field_name, index) {
        let comment = this.fieldComments[index].value
        this.$message(comment)
      },
      showComment(field_comment) {

      },
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw)
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg'
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!')
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
        }
        return isJPG && isLt2M
      },
      saveFormData() {
        if (!this.formDataIsValid()) {
          return
        }

        this.saving = true
        
        var equipment_id = Utils.getEquipmentID()
        var values_json = JSON.stringify(this.fieldValues)
        let that = this

        var requestUrl = '/form/web/_add_record_save_data.jsp'

        let data = {
          equipment_id: equipment_id,
          form_id: that.form_id,
          values_json: values_json
        }

        var qs = require('qs')

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: '正在保存,请稍候...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        this.axios.post(
            requestUrl,
            qs.stringify(data), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          ).then(function(response) {
            if (response.data.result === '1') {
              that.$message.success('保存成功！')
              that.back()
            } else {
              that.$message.error('保存失败，请重试！')
            }
            
            that.saving = false
            load.close()
          })
          .catch(function(error) {
            console.log(error)
            that.$message.error('网络异常，保存失败！')
            that.saving = false
            load.close()
          })
      },
      clearAllData() {
        let that = this
        that.fieldValues = []
        if (that.fieldValues.length === 0) {
          // 初始化数据
          for (var i = 0; i < that.formFields.length; i++) {
            if (that.formFields[i].field_type === '自动时间') {
              var currentTime = Utils.getCurrentDateTime()
              that.fieldValues.push(currentTime)
            } else if (that.formFields[i].field_type === '多选') {
              that.fieldValues.push([])
            } else {
              that.fieldValues.push('')
            }
          }
        }
      },
      formDataIsValid() {
        var isValid = true
        for (var i = 0; i < this.formFields.length; i++) {
          var field = this.formFields[i]

          var fName = field.field_name
          var fValue = this.fieldValues[i]
          var fType = field.field_type
          var fOptional = field.optional

          if (fOptional !== 1) {
            if (Utils.isEmpty(fValue)) {
              if (fType === '文本' || fType === '数字') {
                this.$message.error('请输入' + fName)
              } else if (fType === '日期') {
                this.$message.error('请选择' + fName)
              } else if (fType === '身份证号') {
                this.$message.error('请输入' + fName)
              } else if (fType === '手机号') {
                this.$message.error('请输入' + fName)
              } else if (fType === '车牌号') {
                this.$message.error('请输入' + fName)
              } else if (fType === 'Email邮箱') {
                this.$message.error('请输入' + fName)
              }

              isValid = false
              break
            }
          }
        }

        return isValid
      },
      loadSingleOptions(field_name) {
        var options = []

        for (var i = 0; i < this.field_options.length; i++) {
          var item = this.field_options[i]
          if (item.key === field_name) {
            options = item.values
          }
        }

        return options
      },
      loadMutiOptions(field_name) {
        var options = []

        for (var i = 0; i < this.field_options.length; i++) {
          var item = this.field_options[i]
          if (item.key === field_name) {
            var values = item.values

            for (var j = 0; j < values.length; j++) {
              var valueItem = values[j]
              options.push({
                label: valueItem,
                value: valueItem
              })
            }

            break
          }
        }

        return options
      }

    }
  }
</script>

<style scoped>
  .add-record-container {
    min-height: 100vh;
    background: #f5f7fa;
  }

  .main-content-wrapper {
    min-height: calc(100vh - 60px);
  }

  .full-height {
    min-height: 100%;
  }

  .sidebar-col {
    background: #fff;
    border-right: 1px solid #f0f0f0;
    min-height: calc(100vh - 60px);
  }

  .content-col {
    padding: 20px;
    min-height: calc(100vh - 60px);
  }

  /* 页面头部 */
  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;
    padding: 20px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  }

  .page-title-section {
    flex: 1;
  }

  .page-title {
    font-size: 24px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0 0 8px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .page-subtitle {
    font-size: 14px;
    color: #666;
    margin: 0;
  }

  .action-section {
    margin-left: 20px;
  }

  .back-btn {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    border: none;
    color: #fff;
    border-radius: 8px;
    padding: 10px 20px;
    box-shadow: 0 4px 12px rgba(20, 133, 251, 0.2);
    transition: all 0.3s ease;
  }

  .back-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(20, 133, 251, 0.3);
  }

  .back-btn i {
    margin-right: 6px;
  }

  /* 表单容器 */
  .form-container-wrapper {
    padding: 0 20px 20px;
  }

  .form-container {
    background: #fff;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid #f0f0f0;
  }

  /* 表单头部信息 */
  .form-header {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    padding: 30px;
    border-bottom: 1px solid #f0f0f0;
  }

  .form-info-card {
    background: #fff;
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 24px;
    border: 1px solid #f0f0f0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }

  .form-title-section {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  .form-icon {
    width: 56px;
    height: 56px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    color: #fff;
    font-size: 24px;
  }

  .form-text {
    flex: 1;
  }

  .form-name {
    font-size: 22px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0 0 8px;
  }

  .form-meta {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .form-id {
    font-size: 13px;
    color: #666;
    background: #f5f5f5;
    padding: 4px 12px;
    border-radius: 20px;
  }

  .form-divider {
    color: #ddd;
  }

  .form-status {
    font-size: 13px;
    color: #2CCB92;
    font-weight: 500;
  }

  .form-description {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 12px 16px;
    background: #e6f7ff;
    border-radius: 8px;
    font-size: 14px;
    color: #1485FB;
  }

  .form-description i {
    margin-top: 2px;
    color: #1485FB;
  }

  /* 填写进度 */
  .progress-section {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    border: 1px solid #f0f0f0;
  }

  .progress-stats {
    display: flex;
    gap: 20px;
    margin-bottom: 16px;
  }

  .stat-item {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .stat-icon {
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, #f0f7ff 0%, #e6f0ff 100%);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1485FB;
    font-size: 16px;
  }

  .stat-content {
    display: flex;
    flex-direction: column;
  }

  .stat-value {
    font-size: 20px;
    font-weight: 600;
    color: #1a1a1a;
  }

  .stat-label {
    font-size: 12px;
    color: #888;
  }

  .progress-notice {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: #fff7e6;
    border-radius: 8px;
    font-size: 13px;
    color: #ffa940;
  }

  .progress-notice i {
    color: #ffa940;
  }

  .required-star {
    color: #f56c6c;
    font-size: 20px;
    margin-left: 4px;
    vertical-align: middle;
  }

  /* 表单字段 */
  .form-fields-container {
    padding: 30px;
  }

  .fields-list {
    max-width: 800px;
    margin: 0 auto;
  }

  .field-item {
    background: #fff;
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 24px;
    border: 1px solid #f0f0f0;
    transition: all 0.3s ease;
  }

  .field-item:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    border-color: #e0e0e0;
  }

  .field-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  .field-title {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .field-number {
    width: 28px;
    height: 28px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
  }

  .field-name {
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
  }

  .field-actions {
    margin-left: auto;
  }

  .field-help-link {
    font-size: 12px;
    color: #888;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    transition: color 0.2s ease;
  }

  .field-help-link:hover {
    color: #1485FB;
  }

  .field-help-link i {
    font-size: 14px;
  }

  .field-type-hint {
    font-size: 13px;
    color: #888;
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px dashed #f0f0f0;
  }

  .field-type-label {
    font-weight: 500;
    margin-right: 8px;
  }

  .optional-label {
    color: #2CCB92;
  }

  .required-label {
    color: #f56c6c;
  }

  /* 字段输入组件 */
  .field-input-wrapper {
    margin-top: 8px;
  }

  .text-field-input ::v-deep .el-textarea__inner {
    border-radius: 8px;
    border: 2px solid #e8e8e8;
    transition: all 0.3s ease;
    font-size: 14px;
  }

  .text-field-input ::v-deep .el-textarea__inner:focus {
    border-color: #1485FB;
    box-shadow: 0 0 0 3px rgba(20, 133, 251, 0.1);
  }

  .number-field-input ::v-deep .el-input__inner,
  .id-card-input ::v-deep .el-input__inner,
  .phone-input ::v-deep .el-input__inner,
  .email-input ::v-deep .el-input__inner,
  .license-plate-input ::v-deep .el-input__inner {
    border-radius: 8px;
    border: 2px solid #e8e8e8;
    transition: all 0.3s ease;
    font-size: 14px;
  }

  .number-field-input ::v-deep .el-input__inner:focus,
  .id-card-input ::v-deep .el-input__inner:focus,
  .phone-input ::v-deep .el-input__inner:focus,
  .email-input ::v-deep .el-input__inner:focus,
  .license-plate-input ::v-deep .el-input__inner:focus {
    border-color: #1485FB;
    box-shadow: 0 0 0 3px rgba(20, 133, 251, 0.1);
  }

  .auto-time-input ::v-deep .el-input-group__prepend {
    background: #f5f7fa;
    border: 2px solid #e8e8e8;
    border-right: none;
    border-radius: 8px 0 0 8px;
  }

  .auto-time-input ::v-deep .el-input__inner {
    border-radius: 0 8px 8px 0;
    border: 2px solid #e8e8e8;
    border-left: none;
    background: #fafbfc;
  }

  .date-picker ::v-deep .el-input__inner,
  .datetime-picker ::v-deep .el-input__inner {
    border-radius: 8px;
    border: 2px solid #e8e8e8;
    transition: all 0.3s ease;
    font-size: 14px;
  }

  .date-picker ::v-deep .el-input__inner:focus,
  .datetime-picker ::v-deep .el-input__inner:focus {
    border-color: #1485FB;
    box-shadow: 0 0 0 3px rgba(20, 133, 251, 0.1);
  }

  .radio-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .radio-item ::v-deep .el-radio__inner {
    border-color: #c0c4cc;
  }

  .radio-item ::v-deep .el-radio__input.is-checked .el-radio__inner {
    border-color: #1485FB;
    background: #1485FB;
  }

  .checkbox-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .checkbox-item ::v-deep .el-checkbox__inner {
    border-color: #c0c4cc;
  }

  .checkbox-item ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #1485FB;
    background: #1485FB;
  }

  /* 通知卡片 */
  .field-notice {
    margin-top: 16px;
  }

  .notice-card {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    background: #fafbfc;
    border-radius: 8px;
    border: 1px solid #f0f0f0;
  }

  .notice-icon {
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, #fff2e8 0%, #ffe7d9 100%);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffa940;
    font-size: 18px;
  }

  .notice-content h4 {
    font-size: 14px;
    font-weight: 600;
    color: #1a1a1a;
    margin: 0 0 4px;
  }

  .notice-content p {
    font-size: 12px;
    color: #888;
    margin: 0;
  }

  /* 表单操作按钮 */
  .form-actions {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-top: 40px;
    padding-top: 24px;
    border-top: 1px solid #f0f0f0;
  }

  .save-btn {
    background: linear-gradient(135deg, #2CCB92 0%, #25b582 100%);
    border: none;
    color: #fff;
    border-radius: 8px;
    padding: 12px 32px;
    font-size: 16px;
    font-weight: 500;
    height: 48px;
    box-shadow: 0 4px 12px rgba(44, 203, 146, 0.3);
    transition: all 0.3s ease;
  }

  .save-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(44, 203, 146, 0.4);
  }

  .save-btn i {
    margin-right: 8px;
  }

  .save-btn.is-loading {
    opacity: 0.8;
    cursor: not-allowed;
  }

  .reset-btn {
    background: #fff;
    border: 2px solid #f0f0f0;
    color: #666;
    border-radius: 8px;
    padding: 12px 32px;
    font-size: 16px;
    height: 48px;
    transition: all 0.3s ease;
  }

  .reset-btn:hover {
    border-color: #1485FB;
    color: #1485FB;
    background: #f5f7fa;
  }

  .reset-btn i {
    margin-right: 8px;
  }

  /* 响应式设计 */
  @media (max-width: 992px) {
    .sidebar-col {
      display: none;
    }
    
    .content-col {
      width: 100%;
      padding: 15px;
    }
    
    .page-header {
      flex-direction: column;
      gap: 16px;
      padding: 15px;
    }
    
    .action-section {
      margin-left: 0;
      align-self: flex-start;
    }
    
    .form-header {
      padding: 20px;
    }
    
    .form-fields-container {
      padding: 20px;
    }
    
    .form-info-card {
      padding: 16px;
    }
    
    .form-title-section {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }
    
    .form-icon {
      width: 48px;
      height: 48px;
      font-size: 20px;
      margin-right: 0;
      margin-bottom: 8px;
    }
    
    .progress-stats {
      flex-direction: column;
      gap: 12px;
    }
    
    .field-item {
      padding: 16px;
    }
    
    .field-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
    
    .field-actions {
      margin-left: 0;
      align-self: flex-start;
    }
    
    .form-actions {
      flex-direction: column;
      gap: 12px;
    }
    
    .save-btn,
    .reset-btn {
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    .content-col {
      padding: 10px;
    }
    
    .page-header {
      margin-bottom: 16px;
    }
    
    .form-container-wrapper {
      padding: 0 10px 10px;
    }
    
    .form-header {
      padding: 15px;
    }
    
    .form-fields-container {
      padding: 15px;
    }
    
    .fields-list {
      max-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/add_record.vue